/**
 * Extracts the start and end times from a given time range string.
 *
 * @param {string} timeString - The time range string in the format "hh:mm AM/PM-hh:mm AM/PM".
 * @returns {Object|null} An object containing startTime and endTime properties, or null if the input is invalid.
 */
export function extractTimeRange(timeString) {
    // Define a regular expression pattern to match the time format
    var timePattern = /(\d{2}:\d{2} [APMapm]{2})-(\d{2}:\d{2} [APMapm]{2})/;

    // Use the match method to extract the time range
    var matchResult = timeString.match(timePattern);

    if (matchResult) {
        // matchResult[1] contains the starting time
        // matchResult[2] contains the ending time
        return {
            startTime: matchResult[1],
            endTime: matchResult[2]
        };
    } else {
        // Return an error or handle invalid input
        return null;
    }
}